import React from 'react';

import './TrunkshowPageSubtitle.scss';

interface Props {
  children: string;
}

export const TrunkshowPageSubtitle: React.FC<Props> = ({ children }) => (
  <h3 className="TrunkshowPageSubtitle">{children}</h3>
);
